import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import useUserStore from "../../../../utils/storeApp";
import CallAPI from "../../../../services/apiCalls";
import { Column } from "primereact/column";
import $ from "jquery";
import { useReactToPrint } from "react-to-print";
import ReportsDropdown from "../ReportsDropdown";
import * as moment from "moment";
import { CSVLink } from "react-csv";
import SharedMsg from "../../SharedMsg";

const ListUserActivity = () => {
  const navigate = useNavigate();
  const { isUserLogedIn, userRole, userToken, sharedObject, SetSharedObject } =
    useUserStore((state) => ({
      isUserLogedIn: state.isUserLogedIn,
      userRole: state.userRole,
      userToken: state.userToken,
      sharedObject: state.sharedObject,
      SetSharedObject: state.SetSharedObject,
    }));
  const [userObj, setUserObj] = useState([]);
  const [historyData, setHistoryData] = useState([]);
  const [activityHistory, setActivityHistory] = useState({});
  const [count, setCount] = useState(0);
  const [refreshObj, SetRefreshObj] = useState(false);
  const [processing, SetProcessing] = useState(false);

  useEffect(() => {
    let obj = sharedObject.UserActiviySearch;
    if (obj && Object.keys(obj).length > 0) {
      setLast(obj.count < 25 ? obj.count : 25);
      gridData(obj);
    }
  }, [sharedObject.UserActiviySearch]);
  const getReport = async (src, pg) => {
    SetProcessing(true);
    let call =
      "/reports/UserActivity?searchPhrase=''&sortDir=SentDate&sortBy=SentDate&current=" +
      pg;
    SetRefreshObj(src);
    const res = await CallAPI(call, src, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      gridData(res.data.data);
      SetProcessing(false);
    } else {
      SetProcessing(false);
    }
  };
  const gridData = (obj) => {
    let cnt = obj.count;
    setCount(cnt);
    let tempObj = [];
    for (const row of obj.pageItems) {
      let cs = (
        <button
          className="btn btn-link  border-0 align-baseline"
          onClick={(el) => {
              userHistory(row);
              el.preventDefault();
          }}
        >
          <strong>{row.userNameDisplay}</strong>
        </button>
      );
      row.nameDisplay = cs;
      tempObj.push(row);
    }
    setUserObj(tempObj);
  };
  const userHistory = async (el) => {
    setActivityHistory(el);
    const yourDate = new Date();
    const NewDate = moment(yourDate).format("MM/DD/YYYY");
    let lastYear = moment().subtract(1, "year");

    let search = {
      EventDomain: el.domainName,
      EventValue: el.userName,
      StartDate: new Date(lastYear),
      EndDate: new Date(NewDate),
    };
    SetProcessing(true);
    let call =
      "/reports/UserHistory?current=1&sortDir=SentDate&sortBy=SentDate";
    const res = await CallAPI(call, search, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      setHistoryData(res.data.data.pageItems);
      let obj = {
        ...search,
        List: res.data.data.pageItems,
        Name: el.accountName,
      };
      SetSharedObject("UserActiviyHistory", obj);
      navigate("/user-account-history");
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };
  const sentMessageTemplate = (dt) => {
    return dt.dateLastLogin
      ? new Date(dt.dateLastLogin).toLocaleString("en-US", { hour12: false })
      : null;
  };
  const formatDateAccepted = (dt) => {
    return dt.dateModified
      ? new Date(dt.dateModified).toLocaleString("en-US", { hour12: false })
      : null;
  };
  const formatDateConfirmed = (dt) => {
    return dt.dateCreated
      ? new Date(dt.dateCreated).toLocaleString("en-US", { hour12: false })
      : null;
  };
  const [first, setFirst] = useState(1);
  const [last, setLast] = useState(25);
  const [rows, setRows] = useState(25);
  const onPageChange = (event) => {
    setFirst(event.first + 1);
    setRows(event.rows);
    let lastNr = event.first + 25;
    let last = lastNr > count ? count : lastNr;
    setLast(last);
    let page = event.page + 1;
    SetRefreshObj(sharedObject.messageStatusSearch);
    getReport(sharedObject.messageStatusSearch, page);
  };
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const refreshPage = () => {
    setFirst(1);
    setLast(25);
    getReport(sharedObject.messageStatusSearch, 1);
  };
  
  const bulkDownLoad = () => {
    SetSharedObject("UserActiviyType", "bulk");
    $("#userActivitySearchModal").modal("show");
  };

  const headers = [
    {
      label: "User Name",
      key: "userNameDisplay",
    },
    { label: "Account Name", key: "accountName" },
    { label: "Direct Email", key: "directMail" },
    { label: "Last Login", key: "dateLastLogin" },
    { label: "Last Modified", key: "dateModified" },
    { label: "Modified By", key: "modifiedByDisplay" },
    { label: "Date Created", key: "dateCreated" },
    { label: "Created By", key: "createdByDisplay" },
    { label: "Organization", key: "orgName" },
    ];

    const [loadingText, setLoadingText] = useState("Loading...");
    useEffect(() => {
        let timer;
        if (processing) {
            timer = setTimeout(() => {
                setLoadingText("Working on it...");
            }, 10000);
        } else {
            setLoadingText("Loading...");
        }

        return () => clearTimeout(timer);
    }, [processing]);

  return (
    <main ref={componentRef} className="ListUserActivity">
        <header>
          <div className="spacer-inline sp-margin12">
                <h4 className="title-label3">
                User Activity
            </h4>
         </div>
          <div className="mid-header-bar spacer-inline sp-mx5">
            <ReportsDropdown />
            <button
              className="btn btn-outline-dark sp-margin5 btn-reports-sm"
              data-toggle="modal"
              aria-label="Open user activity search"
              aria-haspopup="dialog"
              onClick={(e) => {
                SetSharedObject("UserActiviyType", "reg");
                $("#userActivitySearchModal").modal("show");
              }}
            >
              <i className="bi bi-search" aria-hidden="true"></i>
            </button>
            <button
              className="btn btn-outline-dark sp-margin5 btn-reports-sm"
              aria-label="Open bulk download mailbox size search"
              aria-haspopup="dialog"
              data-toggle="modal"
              onClick={(e) => {
                bulkDownLoad();
              }}
            >
              <i className="bi bi-box-arrow-down" aria-hidden="true"></i>
            </button>

            <div className="spacer-inline" role="toolbar" aria-label="User activity report export and refresh tools">
                <span className="SharedTools" role="group" aria-label="Export and print tools">
                    {count > 0 ? (
                      <CSVLink
                        filename="ListUserActivity.csv"
                        className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                        aria-label="Download user activity as MS Excel CSV file"
                        data={userObj}
                        headers={headers}
                      >
                        <i className="bi bi-download" aria-hidden="true"></i>
                      </CSVLink>
                    ) : (
                      <button
                            type="button"
                            className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                            disabled
                            aria-disabled="true"
                            aria-label="Download CSV (no results available)"
                          >
                            <i className="bi bi-download" aria-hidden="true"></i>
                       </button>
                    )}
                        <button
                            type="button"
                            className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                            disabled={count === 0}
                            aria-disabled={count === 0}
                            aria-label={
                                count === 0
                                    ? "Refresh report (no results to refresh)"
                                    : "Refresh report"
                            }
                            onClick={(e) => {
                                if (count > 0) refreshPage();
                            }}
                        >
                            <i className="bi bi-arrow-clockwise" aria-hidden="true"></i>
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                            disabled={count === 0}
                            aria-disabled={count === 0}
                            aria-label={
                                count === 0
                                    ? "Print report (no results to print)"
                                    : "Print received messages report"
                            }
                            onClick={(e) => {
                                if (count > 0) handlePrint();
                            }}
                        >
                            <i className="bi bi-printer" aria-hidden="true"></i>
                        </button>
                  </span>
            </div>
          </div>
        </header>
      <div>
        <section className="grid-header-bar" aria-label="Report filter summary">
          {userRole !== "SES ADMINISTRATOR" ? null : (
            <>
            <dl className="sp-mx7 ">
              <div className="spacer-inline spacer-margin1">
                <dt className="ft-wt">Domain:</dt>
                <dd className="sp-margin12 sp-mx7">
                  {sharedObject?.messageStatusSearch?.DomainName
                    ? userObj?.length > 0
                      ? sharedObject?.messageStatusSearch?.DomainName
                      : null
                    : null}
                </dd>
              </div>
              <div className="spacer-inline">
                <dt className="ft-wt">Customer:</dt>
                <dd className="sp-margin12 sp-mx7">
                  {sharedObject?.messageStatusSearch?.VendorName
                    ? userObj?.length > 0
                      ? sharedObject?.messageStatusSearch?.VendorName
                      : null
                    : null}
                </dd>
              </div>
              </dl>
            </>
          )}
          <SharedMsg />
        </section>
        <section className="grid-layout">
          {userObj?.length > 0 ? (
            <div id="SentMessageReport">
              <DataTable
                value={userObj}
                aria-label="User Activity Report"
                rows={25}
                paginator
                selectionPageOnly
                rowsPerPageOptions={[25, 50, 75]}
                tableStyle={{ minWidth: "50rem" }}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                dataKey="Id"
                columnResizeMode="expand"
                resizableColumns
                scrollable
                sortField="dateCreated"
                sortOrder={-1}
              >
                <Column field="nameDisplay" header="User Name" className="print-col" sortable ></Column>
                <Column field="accountName" header="Account Name" className="print-col" sortable ></Column>
                <Column field="directMail" header="Direct Email" className="truncate" sortable ></Column>
                <Column field="dateLastLogin" header="Last Login" className="w-md2" body={sentMessageTemplate} sortable ></Column>
                <Column field="dateModified" header="Last Modified" className="w-md2" sortable body={formatDateAccepted} ></Column>
                <Column field="modifiedByDisplay" header="Modified By" className="print-col" sortable ></Column>
                <Column field="dateCreated" header="Date Created" className="w-md2" sortable body={formatDateConfirmed} ></Column>
                <Column field="createdByDisplay" header="Created By" className="print-col" sortable ></Column>
                <Column field="orgName" header="Organization" className="print-col" sortable ></Column>
              </DataTable>
            </div>
          ) : (
            <section className="empty-grid" role="status" aria-live="polite" aria-atomic="true">
              There are currently no search results.
            </section>
          )}
        </section>

        {processing && (
            <div 
                className="loader-container" 
                role="status" 
                aria-live="polite" 
                aria-atomic="true"
                aria-labelledby="user-activity-loader"
            >
                <div className="spinner" aria-hidden="true"></div>
                <div className="loading-text" id="user-activity-loader">{loadingText}</div>
            </div>
        )}
      </div>
    </main>
  );
};

export default ListUserActivity;
